<template>
  <div>
    <ModuleHeader>Reporte Venta</ModuleHeader>
    <v-overlay :value="loadingData">
      <div class="text-center">
        <v-progress-circular :indeterminate="!hasProgress" :value="progressPercent" size="96" width="8">
          <span v-if="hasProgress">{{ progressPercent }}%</span>
        </v-progress-circular>
        <div class="mt-3">{{ progressText }}</div>
      </div>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col md="3" cols="12" class="input">
                <label>Fecha inicial</label>
                <Datepicker @input="getAperturas()" @selected="selectDate" :value="input_date.format('MM/DD/YYYY')">
                </Datepicker>
              </v-col>
              <v-col md="3" class="input">
                <label>Fecha final</label>
                <Datepicker @input="getAperturas()" @selected="selectDateFinal" :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
              </v-col>
              <v-col md="3" cols="12">
                <v-autocomplete @input="getAperturas()" label="Departamentos" v-model="selectDep" item-text="Nombre"
                  item-value="id" :items="departamentos"></v-autocomplete>
              </v-col>
              <v-col cols="1" md="3">
                <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                  :items="turnosList">
                  <template v-slot:append-outer>
                    <v-btn @click="getAperturas()" x-small color="primary">Buscar turnos</v-btn>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col md="3" cols="12" class="mt-n6">
                <v-autocomplete label="Cliente" v-model="selectClient" :items="comp_clients"></v-autocomplete>
              </v-col>
              <v-col md="3" cols="12" class="mt-n6">
                <v-text-field v-model="input_folio" label="Folio de Venta"></v-text-field>
              </v-col>
              <v-col md="3" cols="12" class="mt-n6">
                <v-text-field v-model="input_orden" label="Numero de orden"></v-text-field>
              </v-col>
              <v-col md="12" cols="12">
                <v-btn depressed @click="cleanFilter()" small color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="buscar()" small color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="false" md="12">
        <div v-if="showEstad" class="segment">
          <h3 class="dividing header">Resumen</h3>
          <div class="five statistics">
            <div class="small statistic">
              <div class="value">
                {{ ventas_comp.length }}
              </div>
              <div class="label">Ventas</div>
            </div>
            <div class="small statistic">
              <div class="value">
                {{ comp_resumen_data.total_productos }}
              </div>
              <div class="label">Productos</div>
            </div>
            <div class="smal statistic">
              <div class="value">
                {{ comp_resumen_data.total_rounds }}
              </div>
              <div class="label">Rondas de Golf</div>
            </div>
            <div class="small statistic">
              <div class="value">
                {{ comp_resumen_data.total_proshop }}
              </div>
              <div class="label">Productos Golf</div>
            </div>
            <div class="small statistic">
              <div class="value">
                $ {{ formatNumber(comp_resumen_data.total) }}
              </div>
              <div class="label">Total MXN</div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col md="12" cols="12">
        <v-tabs v-model="tab">
          <v-tab>Listado de ventas</v-tab>
          <v-tab :disabled="previewDisabled">Resumen</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <!-- <v-btn style="right: 0; position: absolute;" color="green" dark
              @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon>
              Exportar a Excel
            
            </v-btn> -->
            <v-alert v-if="previewDisabled" type="info" outlined class="mt-12">
              Se consultaron {{ progress.turnos }} turnos, por lo que la vista previa se desactivó para evitar que
              el navegador se alente. Se encontraron {{ ventas_comp.length }} registros; descarga el Excel para
              consultarlos.
              <div class="mt-3">
                <v-btn color="success" depressed :loading="exporting" :disabled="exporting || ventas_comp.length === 0"
                  @click="exportPreviewExcel">
                  <v-icon left>mdi-file-excel-box</v-icon>
                  Descargar Excel
                </v-btn>
              </div>
            </v-alert>
            <DataTable v-else class="mt-12" :config="config" :data="ventas_comp" :pageRows="50"
              @buttonClick="dtButtonClick">
            </DataTable>
            <v-card v-if="false">

              <v-btn style="right: 0; position: absolute;" color="green" dark><v-icon>mdi-file-excel-box</v-icon>
                <download-excel type="xls" name="Reporte Venta" :data="excelData">
                  Exportar a Excel
                </download-excel>
              </v-btn>
              <v-card-text>
                <v-simple-table class="mt-4">
                  <thead>
                    <tr>
                      <th>Folio</th>
                      <th>Cliente</th>
                      <th>Alias de venta</th>
                      <th>Fecha</th>
                      <th>Caja</th>
                      <th>Cajero</th>
                      <th>Total</th>
                      <th>Cambio</th>
                      <th>Estatus</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="ventas_comp.length == 0">
                      <td colspan="7">No se encontraron datos</td>
                    </tr>
                    <template v-for="(res, index) in ventas_comp">
                      <tr :key="index">
                        <td>{{ res.Folio }}</td>
                        <td>{{ res.Cliente.Nombre }}</td>
                        <td>{{ res.Cliente.Apodo }}</td>
                        <td>{{ res.fecha }}</td>
                        <td>
                          {{
                            $pgsHelper.getById(data_cajas, "id", res.Caja).Nomb
                          }}
                        </td>
                        <td>
                          {{
                            $pgsHelper.getById(cashiers, "Id", res.Cajero).Nomb
                          }}
                        </td>
                        <td>{{ $pgsHelper.formatNumber(res.Total) }} MXN</td>
                        <td>{{ $pgsHelper.formatNumber(res.Cambio.MXN) }}</td>
                        <td>
                          <b v-bind:class="{
                            'orange--text': res.Devos,
                            'green--text': !res.Devos,
                          }">{{ res.Devos ? "Devolución" : "Activo" }}</b>
                        </td>
                        <td>
                          <button @click="showDetail(res)" class="green basic button mini">
                            Detalles
                          </button>
                          <button @click="printTicket(res)" class="green basic button mini">
                            Ticket
                          </button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <SaleStats v-if="!previewDisabled" :key="keyResume" :ventas="data_ventas" :initDate="input_date.format('YYYY-MM-DD')"
              :endDate="input_date_final.format('YYYY-MM-DD')" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :key="resKey" :selectedRes="selectedRes" />
    </modal>
  </div>
</template>

<style scoped></style>

<script>
import "../../assets/css/sideBar.css";
import Cliente from "../../clases/Cliente.js";
import Modificadores from "../../clases/Modificadores.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import modal from "../MainComponents/modal.vue";
import resumenVenta from "../MainComponents/resumenVenta.vue";
import SaleStats from "../MainComponents/SaleStats.vue";
import ticket from "../../tickets/ticketReprint.vue";
import ticketDevolucion from "../../tickets/ticketDevolucion.vue";
import TicketVenta from "../../clases/TicketVenta.js";
import DataTable from "../MainComponents/DataTable.vue";
import DataTableExporter from "../../clases/ExcelMaker/DataTableExcel";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import Currencies from "../../clases/Currencies";
const QUERY_CHUNK_SIZE = 10;
// con más turnos que este número solo se ofrece la descarga a Excel, sin renderizar la tabla
const PREVIEW_MAX_TURNOS = 50;
// consultas simultáneas por colección; evita saturar la red y permite ver avance desde el inicio
const QUERY_CONCURRENCY = 3;

export default {
  name: "ReporteVentas",
  components: {
    DataTable,
    Datepicker,
    /*Select2,*/
    SaleStats,
    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      cajeros: [],
      familias: [],
      keyResume: 0,
      tab: null,
      selectTurno: "ALL",
      aperturas: [],
      aperturasReq: 0,
      progress: { done: 0, total: 0, stage: "", turnos: 0 },
      previewDisabled: false,
      exporting: false,
      input_orden: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      data_devoluciones: [],
      processed_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      selectDep: "ALL",
      dataToTicket: {},
      meseros: [],
      resKey: 0,
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: false,
        allowExport: true,
        rawText: "Ventas",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
        ],
        fields: [
          {
            text: "Folio",
            value: "Folio",
          },
          {
            text: "Cliente",
            value: "NombreCliente",
          },
          {
            text: "Meseros",
            value: "allMeseros",
          },
          {
            text: "Alias de venta",
            value: "AliasVenta",
          },
          {
            text: "Fecha",
            value: "fecha",
          },
          {
            text: "Caja",
            value: "CajaName",
            canBeFiltered: true,
          },
          {
            text: "Cajero",
            value: "CajeroName",
            canBeFiltered: true,
          },
          {
            text: "Total",
            value: "Total",
            format: (row) => {
              if (row.isDevolucion) {
                return "$ " + this.$pgsHelper.formatNumber(row.Total?.C);
              } else {
                return "$ " + this.$pgsHelper.formatNumber(row.Total);
              }

            },
          },
          {
            text: "Cambio",
            value: "Cambio",
            format: (row) => {
              const cambio = row.Cambio?.[Currencies.getCurrencyDefault()];
              if (cambio) {
                return "$ " + this.$pgsHelper.formatNumber(cambio);
              } else {
                return "0"
              }
            },
          },
          {
            canBeFiltered: true,
            text: "Estatus",
            value: "Devos",
            format: (row) => {
              if (row.isDevolucion) {
                return '<b class="orange--text">Devolución</b>'
              } else if (!row.Devos) {
                return '<b class="green--text">Activo</b>'
              } else {
                return '<b class="primary--text">Con devolución</b>'
              }
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "green",
                text: "Detalles",
                buttonId: "showDetail",
                value: "id",
                showBy: "isVenta",

              },
              {
                color: "green",
                text: "Ticket",
                buttonId: "printTicket",
                value: "id",
                showBy: "id",

              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    progressPercent() {
      if (this.progress.total === 0) return 0;
      return Math.min(
        100,
        Math.round((this.progress.done / this.progress.total) * 100)
      );
    },
    hasProgress() {
      return this.progress.total > 0 && this.progress.done > 0;
    },
    progressText() {
      if (this.progress.stage) return this.progress.stage;
      if (!this.hasProgress) {
        return "Descargando ventas, esto puede tardar unos momentos...";
      }
      if (this.progress.turnos > 0) {
        // cada turno se consulta en ventas y en devoluciones, de ahí el total * 2
        const turnosListos = Math.min(
          this.progress.turnos,
          Math.floor(this.progress.done / 2)
        );
        return `Descargando turnos: ${turnosListos} de ${this.progress.turnos}`;
      }
      return "Descargando ventas...";
    },
    excelDataFacturacion() {
      let tickets = [];
      this.ventas_comp.forEach((venta) => {
        if (venta.Total != 0) {
          if (
            !(venta._ProdIdx || []).includes("MBS-Movimiento") &&
            !(venta._ProdIdx || []).includes("-NMZKJ2fyTWAv4maSf9M") &&
            !(venta._ProdIdx || []).includes("Monedero")
          ) {
            tickets.push({
              Folio: venta.Folio,
              Cliente: venta.Cliente?.Nombre,
              Alias: venta.Cliente?.Apodo,
              Fecha: venta.fecha,
              Total: venta.Total,
              Cambio: venta.Cambio?.[Currencies.getCurrencyDefault()],
            });
          }
        }
      });
      return tickets;
    },
    excelData() {
      const moneda = Currencies.getCurrencyDefault();
      return this.ventas_comp.map((venta) => {
        let estatus = "Activo";
        if (venta.isDevolucion) estatus = "Devolución";
        else if (venta.Devos) estatus = "Con devolución";
        return {
          Folio: venta.isDevolucion ? "-" + venta.Folio : venta.Folio,
          Cliente: venta.Cliente?.Nombre || "",
          Meseros: (venta.allMeseros || []).join(", "),
          "Alias de venta": venta.Cliente?.Apodo || "",
          Fecha: venta.fecha,
          Caja: venta.CajaName || "",
          Cajero: venta.CajeroName || "",
          Total: venta.isDevolucion
            ? 0 - Number(venta.Total?.C || 0)
            : Number(venta.Total || 0),
          Cambio: Number(venta.Cambio?.[moneda] || 0),
          Estatus: estatus,
        };
      });
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });

      return pagos;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    ventas_comp() {
      return this.processed_ventas;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      this.data_ventas.forEach((venta) => {
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });
        total = total + parseInt(venta.Total);
      });
      return {
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        total: total,
      };
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto() });
      });
      return clientes;
    },
  },
  methods: {
    // Calcula totales por producto y venta. Devuelve la suma de pagos de la venta.
    processPagosCatalogo(venta) {
      // el año se calcula una sola vez por venta, no por cada pago
      const is2023 = new moment(venta.FechaCreacion).format("YYYY") == "2023";
      let totales = 0;
      for (const property in venta.Catalogo) {
        const prod = venta.Catalogo[property];
        let totalProd = 0;
        if (prod.Pagos) {
          Object.values(prod.Pagos).forEach((pago) => {
            totales += pago.def.C;
            if (is2023 && prod.STip == "Cuenta") {
              pago.def.C = pago.def.C + pago.dsc.C * -1;
              pago.dsc.C = 0;
              prod.Descuentos = [];
            }
            totalProd += pago.def.C;
          });
        }
        prod.TotalReal = Number(totalProd);
      }
      return totales;
    },
    // Los modificadores solo se usan en los tickets, se calculan al imprimir
    ensureModificadores(venta) {
      for (const property in venta.Catalogo) {
        const prod = venta.Catalogo[property];
        if (prod.Modificadores && !prod.ModificadoresList) {
          prod.ModificadoresList = Modificadores.parseToListOption(
            prod.Modificadores
          );
          let totalModi = 0;
          prod.ModificadoresList.forEach((modi) => {
            totalModi += modi.pco.C;
          });
          prod.totalModi = totalModi;
        }
      }
    },
    // Trabaja sobre arreglos planos (antes de que Vue los vuelva reactivos)
    processAllSales(ventas, devoluciones) {
      const meserosMap = this.$pgsHelper.createIndex(this.meseros, "id");
      ventas.forEach((venta) => {
        venta.isVenta = true;
        venta.allMeseros = [];
        for (const property in venta.Catalogo) {
          const AYB = venta.Catalogo[property].ExtraParams?.AYB;
          if (AYB) {
            const meseroNombre =
              meserosMap.get(AYB.Mesero)?.Nombre || "Sin mesero";
            if (!venta.allMeseros.includes(meseroNombre)) {
              venta.allMeseros.push(meseroNombre);
            }
          }
        }
        venta.sumatoriaTotal = this.processPagosCatalogo(venta);
      });
      devoluciones.forEach((venta) => {
        venta.Cambio = { MXN: 0 };
        venta.isDevolucion = true;
        venta.sumatoriaTotal = this.processPagosCatalogo(venta);
      });
      const data = ventas.concat(devoluciones);
      // el número de folio se calcula una vez por registro, no en cada comparación
      data.forEach((venta) => {
        venta._folioNum = Number(String(venta.Folio).replace(/\D/g, ""));
      });
      return data.sort((a, b) => a._folioNum - b._folioNum || 0);
    },
    exportPreviewExcel() {
      if (this.exporting) return;
      this.exporting = true;
      DataTableExporter.generateExcelBuffer(this.ventas_comp, this.config)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${this.config.rawText}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando:", err))
        .finally(() => {
          this.exporting = false;
        });
    },
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excelData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Reporte Venta.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "showDetail") {
        let venta = this.$pgsHelper.getById(this.ventas_comp, "id", idSelected);
        this.showDetail(venta);
      }
      if (buttonId == "printTicket") {
        let venta = this.$pgsHelper.getById(this.ventas_comp, "id", idSelected);
        this.printTicket(venta);
      }
    },
    async printMasiveTicket(ticketHtml) {
      let html = "";
      let cssTicket = await this.$pgsHelper.getTicketCss();
      setTimeout(async () => {
        html += "<html><head><title>" + document.title + "</title>";
        html += "<style>" + cssTicket + "</style>";
        html += "</head><body >";

        html += ticketHtml;
        html += "</body></html>";
        this.$pgsHelper.printTicket(this, html);
      }, 2000);
    },
    async getTipoCambio(id) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("PDV_TipoCambio", id);

      const tc = await firestore.getDoc(doc);
      let tcdoc = { Id: tc.ref.id, ...tc.data() };
      return tcdoc;
    },
    async printTicket(res, sinPrecio = false) {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/CONF/" + res.Departamento
        );
      let resultConf = data.val();
      let cssTicket = await this.$pgsHelper.getTicketCss();
      let tipoCambio = await this.getTipoCambio(res.TipoCambio);
      res.TC = tipoCambio.TC;
      this.ensureModificadores(res);
      let dataToTicket = res;
      if (!dataToTicket.isVenta) {
        res.FechaVenta = res.Fecha
      }
      let Cajero = this.$pgsHelper.getById(this.cashiers, "Id", res.Cajero);
      dataToTicket.cajero = { NombreCajero: Cajero.Nomb || "Sin Cajero" };
      dataToTicket.sinPrecio = sinPrecio;
      dataToTicket.Depto = resultConf;
      let TVenta = new TicketVenta(dataToTicket);
      TVenta.dataToTicketReprint();
      console.log(TVenta);

      let ticketHtml = this.$pgsHelper.getHtmlFromComponent(
        this,
        res.isVenta ? ticket : ticketDevolucion,
        {
          dataToTicket: TVenta,
          currenciDefault: Currencies.getCurrencyDefault(),
        }
      );
      let html = "";
      //let stylesHtml = "";
      setTimeout(async () => {
        /*for (const node of [
          ...document.querySelectorAll('link[rel="stylesheet"], style'),
        ]) {
          stylesHtml += node.outerHTML;
        }*/

        html += "<html><head><title>" + document.title + "</title>";
        html += "<style>" + cssTicket + "</style>";
        //html+= stylesHtml
        html += "</head><body >";

        html += ticketHtml;
        html += "</body></html>";
        /* if (this.$pgsHelper.getConfig("useServerPrinter")) {
          this.$pgsHelper.printerInServerPrinter(
            "<body>" + ticketHtml + "</body>",
            "<style>" + cssTicket + "</style>",
            "TICKET-PRINTER"
          );
        } else {*/
        /*let defaultPreviousPrinter = await this.$pgsHelper.getDefaultPrinter(
            this
          );
          let printer = this.$pgsHelper.getPrinter("tickets");
          if (printer != false) {
            await this.$pgsHelper.usePrinter(printer);
          }*/
        this.$pgsHelper.printTicket(this, html);
        /* }*/
        //this.$pgsHelper.printTicket(this, html,defaultPreviousPrinter);
      }, 2000);
    },
    async getAperturas() {
      // si el usuario cambia fechas rápido, solo vale la última respuesta
      const reqId = ++this.aperturasReq;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }

      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      const cajasMapA = this.$pgsHelper.createIndex(this.data_cajas, 'id');
      const cajerosMapA = this.$pgsHelper.createIndex(this.cajeros, 'Id');
      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = cajasMapA.get(apt.Caja) || {};
        let cajeroData = cajerosMapA.get(apt.Cajero) || {};
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      if (reqId !== this.aperturasReq) return;
      this.aperturas = aperturas;
      if (
        this.selectTurno != "ALL" &&
        !aperturas.some((a) => a.Turno == this.selectTurno)
      ) {
        this.selectTurno = "ALL";
      }
    },
    cleanFilter() {
      (this.input_date = moment()),
        (this.input_date_final = moment()),
        (this.input_folio = "");
      this.selectClient = "";
      this.input_orden = "";
      this.selectTurno = "ALL";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.resKey++;
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async buscar() {
      this.loadingData = true;
      this.progress = { done: 0, total: 0, stage: "Buscando turnos...", turnos: 0 };
      try {
        // refrescar turnos con el rango actual para no depender de una carga previa
        await this.getAperturas();
        // una consulta por lote de turnos, para ventas y para devoluciones
        const totalTurnos =
          this.input_folio != "" ? 0 : this.turnosABuscar().length;
        this.previewDisabled = totalTurnos > PREVIEW_MAX_TURNOS;
        // el resumen procesa todo el dataset: con muchos turnos no se calcula
        if (this.previewDisabled) this.tab = 0;
        this.progress = {
          done: 0,
          total: this.input_folio != "" ? 2 : totalTurnos * 2,
          stage: "",
          turnos: totalTurnos,
        };
        const [ventas, devoluciones] = await Promise.all([
          this.getVentas(),
          this.getDevoluciones(),
        ]);
        this.progress.stage = "Procesando información...";
        await this.$nextTick();
        const processed = this.processAllSales(ventas, devoluciones);
        this.data_ventas = ventas;
        this.data_devoluciones = devoluciones;
        this.processed_ventas = processed;
        this.showEstad = true;
        this.keyResume++;
      } catch (error) {
        console.error("Error consultando ventas:", error);
      } finally {
        this.loadingData = false;
      }
    },
    turnosABuscar() {
      return [
        ...new Set(
          this.selectTurno != "ALL"
            ? [this.selectTurno]
            : this.aperturas.map((a) => a.Turno)
        ),
      ].filter((t) => t !== undefined && t !== null);
    },
    async queryByTurnos(collectionName) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const tenant = this.$store.getters.getFirebaseApp.tenant;
      const toDocs = (snap) =>
        snap.docs.map((doc) => ({ id: doc.ref.id, ...doc.data() }));

      if (this.input_folio != "") {
        const snap = await firestore.queryBuilder(collectionName, [
          firestore.where("Folio", "==", this.input_folio),
          firestore.where("Tenant", "==", tenant),
        ]);
        this.progress.done++;
        return toDocs(snap);
      }

      const turnos = this.turnosABuscar();
      if (turnos.length === 0) return [];

      const baseFilters = [firestore.where("Tenant", "==", tenant)];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        baseFilters.push(firestore.where("Departamento", "==", this.selectDep));
      }
      if (this.input_orden != "") {
        baseFilters.push(firestore.where("Orden", "==", this.input_orden));
      }
      if (this.selectClient != "") {
        baseFilters.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      // "in" admite hasta 30 valores; lotes chicos para que el avance sea fluido
      const chunks = [];
      for (let i = 0; i < turnos.length; i += QUERY_CHUNK_SIZE) {
        chunks.push(turnos.slice(i, i + QUERY_CHUNK_SIZE));
      }
      const results = new Array(chunks.length);
      let next = 0;
      const worker = async () => {
        while (next < chunks.length) {
          const idx = next++;
          const snap = await firestore.queryBuilder(collectionName, [
            ...baseFilters,
            firestore.where("Turno", "in", chunks[idx]),
          ]);
          // se pasa a objetos planos al instante para soltar el snapshot de Firestore
          results[idx] = toDocs(snap);
          this.progress.done += chunks[idx].length;
        }
      };
      await Promise.all(
        Array.from({ length: Math.min(QUERY_CONCURRENCY, chunks.length) }, worker)
      );
      return results.flat();
    },
    prepareDocs(docs, dateField) {
      const cajasMap = this.$pgsHelper.createIndex(this.data_cajas, "id");
      const cashiersMap = this.$pgsHelper.createIndex(this.cashiers, "Id");
      // el IVA depende solo de la familia: se resuelve una vez por familia
      const ivaCache = new Map();
      const getIva = (idFamilia) => {
        if (!ivaCache.has(idFamilia)) {
          ivaCache.set(
            idFamilia,
            this.$pgsHelper.getIvaByFamilia(this.familias, idFamilia)
          );
        }
        return ivaCache.get(idFamilia);
      };
      docs.forEach((item) => {
        item.fecha = new moment(item[dateField]).format("YYYY-MM-DD HH:mm");
        item.NombreCliente = item.Cliente.Nombre;
        item.AliasVenta = item.Cliente.Apodo;
        item.CajaName = (cajasMap.get(item.Caja) || {}).Nomb || "";
        item.CajeroName = (cashiersMap.get(item.Cajero) || {}).Nomb || "";
        item.Catalogo.forEach((prod) => {
          prod.ivaPercent = getIva(prod.Familia.I);
        });
      });
      return this.$_.orderBy(docs, "fecha", "desc");
    },
    async getVentas() {
      const docs = await this.queryByTurnos("PDV_Ventas");
      return this.prepareDocs(docs, "FechaCreacion");
    },
    async getDevoluciones() {
      const docs = await this.queryByTurnos("PDV_Devoluciones");
      return this.prepareDocs(docs, "Crat");
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          let deptos = Object.entries(mesero.Deptos);
          let textDepto = "";
          deptos.forEach((depto) => {
            let testDepto = this.$pgsHelper.getById(
              this.departamentos,
              "Id",
              depto[0]
            );
            if (testDepto) {
              textDepto = textDepto + testDepto.Nombre + " ";
            }
          });
          mesero.DepartamentoText = textDepto;
        });
      }
    },
  },
  beforeCreate: function () { },
  beforeMount: async function () {
    await this.getAperturas();
    await this.getFamilias();
    await this.getMeserosAB();
    //this.getVentas();
    //this.getDevoluciones();
    this.getCajas();
    this.getCashiers();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
